import React, { useContext } from "react";

import isTouchDevice from "../SE-Component/Tooltip";
import embLabels from "../../config/emb-labels-en.json";
import { InformationPageContext } from "../CustomHooks/ContextApi";
import Tooltip from "../../utils/Tooltip";
import { getProjectTypeValue } from "../../utils/project";
import useProjectTypeValue from "../../utils/useCurrentProjectValue";

const GenericSiteType = ({ isA2E }) => {
  const {
    projectType,
    informationToolTIP,
    siteType,
    handleSiteTypeChange,
    handlePackageMGSiteTypeChange,
    findProjectTypeHandler,
    projectTypeValue
  } = useContext(InformationPageContext);
  

  return ( 
    <>
      {projectType && (
        <div className="row">
          <div className="col-md-12 mt-1">
            <span className="labelCircle mr-2 ">2</span>{" "}
            {projectType === embLabels.STANDARD_MICROGRID ? (
              <span>Select your microgrid type</span>
            ) : (
              <span>Select your pre-configured site</span>
            )}
            <Tooltip
              position="right"
              iconColor="secondary"
              iconSize="small"
              information={projectType === embLabels.STANDARD_MICROGRID
                ? informationToolTIP?.selectMicrogridTypeToolTipData
                : "Select your pre-configured site."}
            />           
          </div>
        </div>
      )}

      {projectType === embLabels.STANDARD_MICROGRID && (
        <div className="row is-flex mt-2">
          <div className="col-md-4">
            <div
              className={`col-md-12 ${
                siteType === embLabels.GRID_CONNECTED
                  ? "border-green-radius-5px"
                  : "border-radius-5px"
              }`}
            >
              <div className="row align-items-center">
                <div className="col-md-2">
                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                    <div className="custom-control custom-radio">
                      <input
                      data-help-id = {"gs_grid"}
                        type="radio"
                        id={"gs_grid"}
                        name="siteType"
                        className="custom-control-input islandableRadio asCompatible"
                        value="GRID_CONNECTED"
                        checked={
                          siteType === embLabels.GRID_CONNECTED ? true : false
                        }
                        onChange={handleSiteTypeChange}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor={"gs_grid"}
                      >
                        &zwnj;
                      </label>
                    </div>
                  </div>
                </div>

                <div className="col-md-10 p-2">
                  <div className="row">
                    <div className="col-md-12 mt-1">
                      <span className="bold"><label htmlFor={"gs_grid"}  className="m-0">Always grid tied</label></span>
                    </div>
                    <div className="col-md-12 mt-1">
                      <span>
                        <label htmlFor={"gs_grid"} className="m-0">"{informationToolTIP?.gridConnectedTooltipData}"</label>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* don't delete this code here */}
       { <div className={`col-md-4`}>
          {/* <div className={`col-md-4 `}> */}
            <div
              className={`col-md-12 ${
                siteType === embLabels.ISLANDABLE
                  ? "border-green-radius-5px"
                  : "border-radius-5px"
              }`}
            >
              <div className={`row align-items-center`}>
                <div className="col-md-2">
                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                    <div className="custom-control custom-radio">
                      <input
                      data-help-id = {"gs_islandable"}
                        type="radio"
                        id={"gs_islandable"}
                        name="siteType"
                        className="custom-control-input islandableRadio asCompatible"
                        value="ISLANDABLE"
                        checked={
                          siteType === embLabels.ISLANDABLE ? true : false
                        }
                        // onChange={projectTypeValue ==="MGaaS IEC"?undefined:handleSiteTypeChange}
                        onChange={handleSiteTypeChange}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor={"gs_islandable"}
                      >
                        &zwnj;
                      </label>
                    </div>
                  </div>
                </div>

                <div className="col-md-10 p-2">
                  <div className="row">
                    <div className="col-md-12 mt-1">
                      <span className="bold"><label htmlFor={"gs_islandable"}  className="m-0">Islandable site</label></span>
                    </div>
                    <div className="col-md-12 mt-1">
                    <span><label htmlFor={"gs_islandable"}>"{informationToolTIP?.islandableTooltipData}"</label></span>
                     {/* {projectTypeValue ==="MGaaS IEC"?<span>"Coming Soon H2 2024"</span>: <span>"{informationToolTIP.islandableTooltipData}"</span>} */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}

         {(findProjectTypeHandler() === embLabels.GENERIC_PROJECT&& projectTypeValue!=="MGaaS ANSI" &&  projectTypeValue !=="MGaaS IEC" && !["MGaaS ETO"].includes(projectTypeValue)) &&
          <div className={`col-md-4 ${(projectTypeValue ==="MGaaS IEC" || projectTypeValue==="MGaaS ETO" )?"se-block-disabled":""}`}>
         {/* <div className={`col-md-4 `}> */}
            <div
              className={`col-md-12 ${
                siteType === embLabels.OFF_GRID
                  ? "border-green-radius-5px"
                  : "border-radius-5px"
              }`}
            >
              <div className={`row align-items-center  ${(projectTypeValue ==="MGaaS IEC" || projectTypeValue==="MGaaS ETO" )?"mt-2":""}`}>
                <div className="col-md-2">
                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                    <div className="custom-control custom-radio">
                      <input
                      data-help-id = {"gs_off_grid"}
                        type="radio"
                        id={"gs_off_grid"}
                        name="siteType"
                        className="custom-control-input islandableRadio asCompatible"
                        value="OFF_GRID"
                        checked={siteType === embLabels.OFF_GRID ? true : false}
                        onChange={(projectTypeValue ==="MGaaS IEC" || projectTypeValue==="MGaaS ETO" )?undefined:handleSiteTypeChange}
                        // onChange={handleSiteTypeChange}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor={"gs_off_grid"}
                      >
                        &zwnj;
                      </label>
                    </div>
                  </div>
                </div>

                <div className="col-md-10 p-2">
                  <div className={`row `}>
                    <div className="col-md-12 mt-1">
                     <span className="bold"><label htmlFor={"gs_off_grid"}  className="m-0">Always off grid site</label></span>
                    </div>
                    <div className="col-md-12 mt-1">
                    {/* <span>"{informationToolTIP.offGridTooltipData}"</span> */}
                     {(projectTypeValue ==="MGaaS IEC" || projectTypeValue==="MGaaS ETO" )?<span><label htmlFor={"gs_off_grid"}  className="m-0">"Coming Soon H2 2024"</label></span>:  <span><label htmlFor={"gs_off_grid"}  className="m-0">"{informationToolTIP?.offGridTooltipData}"</label></span>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}
        </div>
      )}

      {projectType === embLabels.PACKAGED_MICROGRID &&
        (!isA2E ? (
          <div className="row mt-2">
            <div className="col-md-4">
              <div
                className={`col-md-12 ${
                  siteType === embLabels.PV_HYBRIDIZATION
                    ? "border-green-radius-5px"
                    : "border-radius-5px"
                }`}
              >
                <div className="row align-items-center">
                  <div className="col-md-2">
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                      <div className="custom-control custom-radio">
                        <input
                        data-help-id = {"PV_HYBRIDIZATION"}
                          type="radio"
                          id={"PV_HYBRIDIZATION"}
                          name="siteType"
                          className="custom-control-input islandableRadio asCompatible"
                          value="PV_HYBRIDIZATION"
                          checked={
                            siteType === embLabels.PV_HYBRIDIZATION
                              ? true
                              : false
                          }
                          onChange={handlePackageMGSiteTypeChange}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor={"PV_HYBRIDIZATION"}
                        >
                          &zwnj;
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-10 p-2">
                    <div className="row">
                      <div className="col-md-12 mt-1">
                        <span className="bold"><label  className="m-0" htmlFor={"PV_HYBRIDIZATION"}>Genset/PV hybridization</label></span>
                      </div>
                      <div className="col-md-12 mt-1">
                        <span>
                          <label  htmlFor={"PV_HYBRIDIZATION"}  className="m-0">"{informationToolTIP?.pvHybridizationToolTip}"</label>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="row mt-2">
            <div className="col-md-4">
              <div
                className={`col-md-12 ${
                  siteType === embLabels.GENSET_PVBESS_A2E
                    ? "border-green-radius-5px"
                    : "border-radius-5px"
                }`}
              >
                <div className="row align-items-center">
                  <div className="col-md-2">
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                      <div className="custom-control custom-radio">
                        <input
                          type="radio"
                           data-help-id = {"GENSET_PVBESS_A2E"}
                          id="customRadio5"
                          name="siteType"
                          className="custom-control-input islandableRadio asCompatible"
                          value="GENSET_PVBESS_A2E"
                          checked={
                            siteType === embLabels.GENSET_PVBESS_A2E
                              ? true
                              : false
                          }
                          onChange={handlePackageMGSiteTypeChange}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="GENSET_PVBESS_A2E"
                        >
                          &zwnj;
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-10 p-2">
                    <div className="row">
                      <div className="col-md-12 mt-1">
                        <span className="bold"><label  className="m-0" htmlFor="GENSET_PVBESS_A2E">Always off grid site</label></span>
                      </div>
                      <div className="col-md-12 mt-1">
                        <span><label htmlFor="GENSET_PVBESS_A2E"  className="m-0">"{informationToolTIP?.offGridTooltipData}"</label></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export default GenericSiteType;
